import { withFormik } from "formik";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Yup from "yup";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from "@material-ui/core/FormHelperText";
import Grid from "@material-ui/core/Grid";
import IconButton from '@material-ui/core/IconButton';
import InputLabel from "@material-ui/core/InputLabel";
import LinearProgress from '@material-ui/core/LinearProgress';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import TextField from "@material-ui/core/TextField";
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

import ClearIcon from "@material-ui/icons/Clear";

import AdminWrapper from "../../containers/AdminWrapper";
//component
import ContentWrapper from "../../containers/ContentWrapper";
//redux actions
import * as dialogActions from "../../redux/actions/dialogactions";
//redux constant
import * as shootTypes from "../../redux/constants/ShootsActionTypes";
//services
import questionService from "../../services/questionService";

import ConfirmationDialog from "../Dialogs/ConfirmationDialog";

class QuestionDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validateCalled: false,
      updatingDetails: false,
      companyLabelWidth: 0
    };
  }

  componentDidMount(){
    // let companyRef = ReactDOM.findDOMNode(this.companyRef);
    // this.setState({
    //   companyLabelWidth: companyRef.offsetWidth
    // });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.confirmDialog && !this.props.confirmDialog) {
      console.log("Modal closed!");
      console.log(prevProps.confirmDialog, this.props.confirmDialog);
      //have a switch to determine what action should we take, but if we only have one action
      //there is no need to have a switch .
      if (this.props.confirmChoice) {
        switch (this.props.confirmAction) {
          case shootTypes.SHOOTS_SAVE_SHOOT:
            console.log("saving shoot");
            this.submitDetails();
            break;
          default:
            break;
        }
      }
    }
  }

  submitDetails = async () => {
    console.log('tawag');
    try {
      this.setState({updatingDetails: true})
        let { role, question } = this.props.values;
        let type = role;
        let id = this.props.match.params.id;
        await questionService.updateQuestion(
          { id },
          { type },
          { question }
        );
        this.setState({updatingDetails: false })
        this.props.history.push("/questions");
    } catch (err) {
      console.log(err);
      this.setState({ updatingDetails: false })
    }
  };

  confirmSaveQuestion = async () => {
    this.setState({ validateCalled: true });
    await this.props.validateForm();
    if (this.props.isValid) {
      this.props.dialogActions.openConfirmDialog(
        "Are you sure?",
        "You are about to update the question.",
        shootTypes.SHOOTS_SAVE_SHOOT,
        "No",
        "Yes"
      );
    }
  };

  render() {
    const { validateCalled } = this.state;
    const {
      handleChange,
      handleBlur,
      errors,
      values,
      touched,
    } = this.props;
    const disabled = this.state.updatingDetails
    return (
      <>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography component="span" variant="h6" color="inherit">
            Question
          </Typography>
          <Button color="primary" onClick={this.confirmSaveQuestion} size="small" disabled={disabled}>
            Update Question
            {disabled ? <CircularProgress color="primary" size={12} style={{ marginLeft: 5 }} /> : null}
          </Button>
        </div>
        {disabled && <LinearProgress color="primary" style={{ height: 2, marginTop: 20 }} />}
        <Paper style={disabled ? { padding: 24 } : { padding: 24, marginTop: 20 }}>
          <Typography component="span" variant="subtitle2" color="inherit" gutterBottom>
            Please update the details of the question.
          </Typography>
          {/* <FormControl
            variant="outlined"
            style={{ width: "100%" }}
            margin="normal"
            error={(touched.role || validateCalled) && errors.role}
          >
            <InputLabel
              ref={ref => {
                this.companyRef = ReactDOM.findDOMNode(ref);
              }}
              htmlFor="outlined-age-native-simple"
            >
              Role
            </InputLabel>
            <Select
              value={values.role}
              native
              input={
                <OutlinedInput
                id="role"
                  labelWidth={this.state.companyLabelWidth}
                  style={{ width: "100%" }}
                  error={
                    (touched.role || validateCalled) && errors.role
                  }
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              }
              disabled={disabled}
            >
              <option value="" />
              <option value="Dentist">Dentist</option>
              <option value="Hygienist">Hygienist</option>
              <option value="Frontdesk">Frontdesk</option>
            </Select>
            {(touched.role || validateCalled) &&
                  <FormHelperText
                    error={
                      (touched.role || validateCalled) && errors.role
                    }
                  >
                    {(touched.role || validateCalled) && errors.role}
                  </FormHelperText>
            }
          </FormControl> */}
          <TextField
            autoComplete="off"
            id="role"
            helperText={(touched.role || validateCalled) && errors.role}
            error={(touched.role || validateCalled) && errors.role}
            value={values.role}
            onBlur={handleBlur}
            onChange={handleChange}
            label="Question"
            margin="normal"
            style={{ width: "100%" }}
            variant="outlined"
            disabled={disabled}
          />
          <TextField
            autoComplete="off"
            id="question"
            helperText={(touched.question || validateCalled) && errors.question}
            error={(touched.question || validateCalled) && errors.question}
            value={values.question}
            onBlur={handleBlur}
            onChange={handleChange}
            label="Question"
            margin="normal"
            style={{ width: "100%" }}
            variant="outlined"
            disabled={disabled}
          />
        </Paper>
        <ConfirmationDialog />
      </>
    );
  }
}

const WithFormikShootDetails = withFormik({
  mapPropsToValues: props => {
    console.log(props)
    let {shootDetails} = props
    return {
      question: shootDetails.question,
      role: shootDetails.role,
    };
  },
  validationSchema: Yup.object().shape({
    question: Yup.string().required("Client question is required!"),
    role: Yup.string().required("Please assign a role.")
  }),
  validateOnChange: true
})(QuestionDetails);



class EditQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question: "",
      role: null,
      shooterList: [],

      saving: false,
      fetching: true,
      failed: false,

      companyLabelWidth: 0
    };
  }

 

  async componentDidMount() {
    //get shoot details
    this.getQuestion();
  }



  getQuestion = async () => {
    try {
      this.setState({ fetching: true });
      let { id, type } = this.props.match.params;
      let { data } = await questionService.getOneQuestion(
        {
          id
        },
        {
          params: {
            type: type,
            id: id
          }
        }
        );
      
      this.setState({
        question: data.question,
        role: data.type,
        fetching: false
      });
    } catch (err) {
      console.log(err);
      this.setState({
        fetching: false,
        failed: true
      });
    }
  };

 
  handleChange = name => e => {
    let state = this.state;
    state[name] = e.target.value;
    this.setState(state);
  };

  //give the components one functions so they can run it
  /*
  pass a function to the dialog component that accepts
  a value argument which is a object of the element that will
  be added to the array.
  {
    name: '',//staffs || languages || services
    value: {
      firstname: "example",
      lastname: "example",
      position: "example"
    }
  }
  */


  handleDateChange = date => {
    this.setState({ selectedDate: date });
  };

  hasInterviewChange = (e, checked) => {
    this.setState({
      hasInterview: checked
    });
  };

  render() {
    return (
      <AdminWrapper {...this.props}>
        <ContentWrapper hasHeader title="Edit Question" hasPadding>
          {this.state.fetching ? (
            <div style={{ textAlign: "center", padding: "50px 0" }}>
              <CircularProgress color="primary" />
            </div>
          ) : (
            <>
              {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={this.props.history.goBack}
                >
                  Back
                </Button>
              </div> */}

              <Toolbar variant="dense" style={{padding: '10px 5px'}} disableGutters={true}>
                <Tooltip title="Cancel">
                  <IconButton onClick={this.props.history.goBack} aria-label="cancel" color="secondary">
                    <ClearIcon/>
                  </IconButton>
                </Tooltip>
                {/* <div style={{flexGrow: 1}} />
                <Tooltip title="Save Shoot">
                  <Button variant="fab" onClick={this.submitDetails} color="primary" mini aria-label="Add" style={{marginLeft: '5px', boxShadow: 'none'}}>
                    <SaveIcon />
                  </Button>
                </Tooltip> */}
              </Toolbar>

              <div style={{ display: "flex", justifyContent: "center" }}>
                <Grid item xd={12} sm={10} md={6} style={{ marginTop: 50 }}>
                  {/* SHOOT DETAILS */}
                  <WithFormikShootDetails 
                    shootDetails={{
                      question: this.state.question,
                      name: this.state.name,
                      created_at: this.state.created_at,
                      selectedDate: this.state.selectedDate,
                      hasInterview: this.state.hasInterview,
                      role: this.state.role
                    }}
                    getDetails={this.getDetails}
                    shooterList={this.state.shooterList}
                    history={this.props.history}
                    location={this.props.location}
                    match={this.props.match}
                    dialogActions={this.props.dialogActions}
                    confirmDialog={this.props.confirmDialog}
                    confirmChoice={this.props.confirmChoice}
                    confirmAction={this.props.confirmAction}
                  />
                  {/* SHOOT DETAILS */}
                 
                </Grid>
              </div>
              {/* SHOOT DETAILS */}
            </>
          )}
        </ContentWrapper>
        <ConfirmationDialog />
      </AdminWrapper>
    );
  }
};

const mapStateToProps = state => {
  return {
    confirmDialog: state.dialog.confirm.open,
    confirmAction: state.dialog.confirm.action,
    confirmChoice: state.dialog.confirm.confirmed
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dialogActions: bindActionCreators(dialogActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditQuestion);
